// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/checkmark_deepSeaGreen.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("images/radio_deepSeaGreen.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RecurringProfileSettings--disabled div > h1,
.RecurringProfileSettings--disabled .row {
  opacity: 0.43;
  pointer-events: none;
}
.RecurringProfileSettings .DocumentContainer {
  padding-left: 40px !important;
  padding-bottom: 20px !important;
  width: calc(100% - 22px) !important;
  margin-left: 22px !important;
  left: 0% !important;
}
.RecurringProfileSettings h1 {
  font-size: 24px;
  font-weight: 500;
  padding-left: 10px;
}
.RecurringProfileSettings .row {
  width: 100%;
}
.RecurringProfileSettings .column {
  vertical-align: top;
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  width: 22%;
}
.RecurringProfileSettings .column.custom div.Input {
  padding-top: 32px;
  width: 50px;
  display: inline-block;
  margin-right: 10px;
}
.RecurringProfileSettings .column.confirmation {
  width: 70%;
}
.RecurringProfileSettings .column.confirmation div.Input {
  margin-top: 40px;
}
.RecurringProfileSettings .help {
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #697588;
}
.RecurringProfileSettings .help .star {
  margin: 6px 6px -4px;
  width: 1.33em;
}
.RecurringProfileSettings .CheckBox span.Label {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  width: calc(100% - 24px) !important;
  overflow: visible;
}
.RecurringProfileSettings .CheckBox .check {
  border-radius: 2px;
}
.RecurringProfileSettings .CheckBox .check.checked {
  background: #01FF94 url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  border: 1px solid #01FF94;
  background-size: 8px 6px;
  background-repeat: no-repeat;
  background-position: 2px 3px;
}
.RecurringProfileSettings > div.toggles {
  background-color: #FFF;
  -webkit-box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
          box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
  overflow-y: auto;
  margin-top: 6px;
  position: absolute;
  z-index: 1000;
  margin-left: -20px;
  margin-right: -20px;
  width: 100%;
  padding: 0 20px 10px 20px;
}
.RecurringProfileSettings > div.toggles > div.ToggleInput {
  margin: 0px !important;
}
.RecurringProfileSettings > div.toggles > div.RadioInput > span.Label {
  color: #002E33;
  text-transform: uppercase;
  font-size: 10px;
}
.RecurringProfileSettings > div.toggles > div.RadioInput > div.Radios > div.radio:first-child {
  margin-top: 6px;
}
.RecurringProfileSettings > div.toggles > div.RadioInput > div.Radios > div.radio {
  margin-bottom: 6px;
  display: inline-block;
  width: 100%;
}
.RecurringProfileSettings > div.toggles > div.RadioInput > div.Radios > div.radio > div.checkable.checked {
  background: #002E33 url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 10px 10px;
  background-repeat: no-repeat;
  background-position: 2px 2px;
}
.RecurringProfileSettings > div.toggles > div.RadioInput > div.Radios > div.radio > div {
  display: inline-block;
}
.RecurringProfileSettings > div.toggles > div.RadioInput > div.Radios > div.radio > div div.Controlled.Input {
  display: inline-block;
  width: 40px;
}
.RecurringProfileSettings > div.toggles > div.RadioInput > div.Radios > div.radio > div div.Controlled.Input input.disabled {
  background-color: #E8E9F0;
  color: #697588;
}
.RecurringProfileSettings > div.toggles > div.RadioInput > div.Radios > div.radio > div span {
  margin-left: 8px;
  display: inline-block;
}
.RecurringProfileSettings > div.toggles > div.RadioInput > div.Radios > div.radio:hover div.checkable {
  border: 1px solid #002E33;
}
.RecurringProfileSettings > div.toggles > div.RadioInput > div.Radios label {
  font-size: 12px;
  color: #697588;
}
.RecurringProfileSettings > div.toggles .Controlled.Input.CheckBox {
  margin-top: 8px;
}
.RecurringProfileSettings > div.toggles .Controlled.Input.CheckBox > span.Label {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  width: calc(100% - 24px) !important;
  overflow: visible;
}
.RecurringProfileSettings > div.toggles .Controlled.Input.CheckBox > span.Label > span {
  white-space: normal;
  overflow: visible;
  text-transform: none;
  font-weight: normal;
  font-size: 12px;
  letter-spacing: normal;
  color: #697588;
  line-height: normal;
}`, "",{"version":3,"sources":["webpack://./src/client/components/invoiceEditor/RecurringProfilesSettings/RecurringProfileSettings.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAMI;;EAEE,aAAA;EACA,oBAAA;AALN;AASE;EACE,6BAAA;EACA,+BAAA;EACA,mCAAA;EACA,4BAAA;EACA,mBAAA;AAPJ;AAUE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AARJ;AAWE;EACE,WAAA;AATJ;AAYE;EACE,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AAVJ;AAcI;EACE,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;AAZN;AAgBE;EACE,UAAA;AAdJ;AAgBI;EACE,gBAAA;AAdN;AAkBE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cCXK;ADLT;AAkBI;EACE,oBAAA;EACA,aAAA;AAhBN;AAqBI;EACE,2BAAA;EAAA,2BAAA;EAAA,oBAAA;EACA,mCAAA;EACA,iBAAA;AAnBN;AAsBI;EACE,kBAAA;AApBN;AAsBM;EACE,2DAAA;EACA,yBAAA;EACA,wBAAA;EACA,4BAAA;EACA,4BAAA;AApBR;AAyBE;EACE,sBCrFI;EDsFJ,wDAAA;UAAA,gDAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;AAvBJ;AAyBI;EACE,sBAAA;AAvBN;AA2BM;EACE,cC5GO;ED6GP,yBAAA;EACA,eAAA;AAzBR;AA6BQ;EACE,eAAA;AA3BV;AA8BQ;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;AA5BV;AA8BU;EACE,2DAAA;EACA,0BAAA;EACA,4BAAA;EACA,4BAAA;AA5BZ;AA+BU;EACE,qBAAA;AA7BZ;AA+BY;EACE,qBAAA;EACA,WAAA;AA7Bd;AA+Bc;EACE,yBCnFP;EDoFO,cCxFP;AD2DT;AAiCY;EACE,gBAAA;EACA,qBAAA;AA/Bd;AAqCU;EACE,yBAAA;AAnCZ;AAuCQ;EACE,eAAA;EACA,cC3GD;ADsET;AA0CI;EACE,eAAA;AAxCN;AA0CM;EACE,2BAAA;EAAA,2BAAA;EAAA,oBAAA;EACA,mCAAA;EACA,iBAAA;AAxCR;AA0CQ;EACE,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,cC/HD;EDgIC,mBAAA;AAxCV","sourcesContent":[".RecurringProfileSettings {\n  @import \"../../../Global/Colors\";\n  @import \"~@zervant/reactcomponents/src/styles/InputBase\";\n\n  &--disabled {\n\n    div>h1,\n    .row {\n      opacity: 0.43;\n      pointer-events: none;\n    }\n  }\n\n  .DocumentContainer {\n    padding-left: 40px !important;\n    padding-bottom: 20px !important;\n    width:calc(100% - 22px) !important;\n    margin-left: 22px !important;\n    left: 0% !important;\n  }\n\n  h1 {\n    font-size: 24px;\n    font-weight: 500;\n    padding-left: 10px;\n  }\n\n  .row {\n    width: 100%;\n  }\n\n  .column {\n    vertical-align: top;\n    display: inline-block;\n    padding-left: 10px;\n    padding-right: 10px;\n    width: 22%;\n  }\n\n  .column.custom {\n    div.Input {\n      padding-top: 32px;\n      width: 50px;\n      display: inline-block;\n      margin-right: 10px;\n    }\n  }\n\n  .column.confirmation {\n    width: 70%;\n\n    div.Input {\n      margin-top: 40px;\n    }\n  }\n\n  .help {\n    font-size: 12px;\n    font-weight: 500;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: 1.33;\n    letter-spacing: normal;\n    text-align: left;\n    color: $Gray90;\n\n    .star {\n      margin: 6px 6px -4px;\n      width: 1.33em;\n    }\n  }\n\n  .CheckBox {\n    span.Label {\n      display: inline-flex;\n      width: calc(100% - 24px) !important;\n      overflow: visible;\n    }\n\n    .check {\n      border-radius: 2px;\n\n      &.checked {\n        background: $ElectricGreen url(\"~images/checkmark_deepSeaGreen.svg\");\n        border: 1px solid $ElectricGreen;\n        background-size: 8px 6px;\n        background-repeat: no-repeat;\n        background-position: 2px 3px;\n      }\n    }\n  }\n\n  >div.toggles {\n    background-color: $White;\n    box-shadow: 0 10px 15px 0 rgba($Gray200, 0.15);\n    overflow-y: auto;\n    margin-top: 6px;\n    position: absolute;\n    z-index: 1000;\n    margin-left: -20px;\n    margin-right: -20px;\n    width: 100%;\n    padding: 0 20px 10px 20px;\n\n    >div.ToggleInput {\n      margin: 0px !important;\n    }\n\n    >div.RadioInput {\n      >span.Label {\n        color: $DeepSeaGreen;\n        text-transform: uppercase;\n        font-size: 10px;\n      }\n\n      >div.Radios {\n        >div.radio:first-child {\n          margin-top: 6px;\n        }\n\n        >div.radio {\n          margin-bottom: 6px;\n          display: inline-block;\n          width: 100%;\n\n          >div.checkable.checked {\n            background: $DeepSeaGreen url(\"~images/radio_deepSeaGreen.svg\");\n            background-size: 10px 10px;\n            background-repeat: no-repeat;\n            background-position: 2px 2px;\n          }\n\n          >div {\n            display: inline-block;\n\n            div.Controlled.Input {\n              display: inline-block;\n              width: 40px;\n\n              input.disabled {\n                background-color: $Gray30;\n                color: $Gray90\n              }\n            }\n\n            span {\n              margin-left: 8px;\n              display: inline-block;\n            }\n          }\n        }\n\n        >div.radio:hover {\n          div.checkable {\n            border: 1px solid $DeepSeaGreen;\n          }\n        }\n\n        label {\n          font-size: 12px;\n          color: $Gray90;\n        }\n      }\n    }\n\n    .Controlled.Input.CheckBox {\n      margin-top: 8px;\n\n      >span.Label {\n        display: inline-flex;\n        width: calc(100% - 24px) !important;\n        overflow: visible;\n\n        >span {\n          white-space: normal;\n          overflow: visible;\n          text-transform: none;\n          font-weight: normal;\n          font-size: 12px;\n          letter-spacing: normal;\n          color: $Gray90;\n          line-height: normal;\n        }\n      }\n    }\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
